import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

let localesRegistered = false;

function ensureLocales() {
  if (localesRegistered) return;
  countries.registerLocale(enLocale);
  localesRegistered = true;
}

function alpha2ToEmoji(alpha2) {
  const code = String(alpha2 || '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return '';
  const base = 0x1F1E6;
  const chars = [...code].map((c) => String.fromCodePoint(base + c.charCodeAt(0) - 65));
  return chars.join('');
}

export function getCountryAlpha2(countryOrAlpha2) {
  if (!countryOrAlpha2) return '';
  const value = String(countryOrAlpha2).trim();
  if (/^[A-Za-z]{2}$/.test(value)) return value.toUpperCase();
  ensureLocales();
  return countries.getAlpha2Code(value, 'en') || '';
}

export function getFlagEmojiByCountryName(countryName) {
  if (!countryName) return '';
  const alpha2 = getCountryAlpha2(countryName);
  return alpha2ToEmoji(alpha2);
}
